import type {
  GraphEntityType,
  GraphRelationDirection,
  RelationKind,
} from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { getGraphRelations } from '../../views/graph/services/graph-service';

export const QUERY_KEY_GRAPH_CONNECTIONS = 'QUERY_KEY_GRAPH_CONNECTIONS';

export const useGraphRelations = ({
  nodeType,
  node,
  relationKind,
  maxRank,
  direction,
}: {
  nodeType: GraphEntityType;
  node: string;
  relationKind?: RelationKind;
  maxRank?: number;
  direction?: GraphRelationDirection;
}) =>
  useQuery({
    queryKey: [
      QUERY_KEY_GRAPH_CONNECTIONS,
      nodeType,
      node,
      relationKind,
      maxRank,
      direction,
    ],
    queryFn: ({ signal }) =>
      getGraphRelations({
        nodeType,
        rawNodeId: node,
        relationKind,
        direction,
        maxRank,
        signal,
      }),
    staleTime: getTimeTillEndOfDayMs(),
  });
